export const environment = {
  production: true,
  apiUrl: 'https://aplicaciones.juyro.com/api/',
  socketUrl: 'https://aplicaciones.juyro.com',
};
